export const AskAIAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/AskAIAnimationData.json';
export const AskAIDarkAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/AskAIDarkAnimationData.json';
export const CloneVoicesAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/CloneVoicesAnimationData.json';
export const CloneVoicesDarkAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/CloneVoicesDarkAnimationData.json';
export const DownloadMP3AnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/DownloadMP3AnimationData.json';
export const DownloadMP3DarkAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/DownloadMP3DarkAnimationData.json';
export const IncreaseSpeedAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/IncreaseSpeedAnimationData.json';
export const IncreaseSpeedDarkAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/IncreaseSpeedDarkAnimationData.json';
export const PremiumVoicesAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/PremiumVoicesAnimationData.json';
export const PremiumVoicesDarkAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/PremiumVoicesDarkAnimationData.json';
export const ScanAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/ScanAnimationData.json';
export const ScanDarkAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/ScanDarkAnimationData.json';
export const SkipAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/SkipAnimationData.json';
export const SkipDarkAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/SkipDarkAnimationData.json';
export const SupportAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/SupportAnimationData.json';
export const SupportDarkAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/SupportDarkAnimationData.json';
export const UnlimitedFilesAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/UnlimitedFilesAnimationData.json';
export const UnlimitedFilesDarkAnimationAssetPath = 'https://cdn.speechify.com/web/animations/upsells/context-headers/UnlimitedFilesDarkAnimationData.json';

export const ALL_CONTEXTUAL_MODAL_ANIMATION_ASSET_PATHS = [
  AskAIAnimationAssetPath,
  AskAIDarkAnimationAssetPath,
  CloneVoicesAnimationAssetPath,
  CloneVoicesDarkAnimationAssetPath,
  DownloadMP3AnimationAssetPath,
  DownloadMP3DarkAnimationAssetPath,
  IncreaseSpeedAnimationAssetPath,
  IncreaseSpeedDarkAnimationAssetPath,
  PremiumVoicesAnimationAssetPath,
  PremiumVoicesDarkAnimationAssetPath,
  ScanAnimationAssetPath,
  ScanDarkAnimationAssetPath,
  SkipAnimationAssetPath,
  SkipDarkAnimationAssetPath,
  SupportAnimationAssetPath,
  SupportDarkAnimationAssetPath,
  UnlimitedFilesAnimationAssetPath,
  UnlimitedFilesDarkAnimationAssetPath
];
